import React, { useEffect, useState } from "react";
import { Form, Checkbox, Row, Col, Input } from "antd";
import _ from "lodash";

interface Props {
  activeQuestion?: any;
  form?: any;
}

const LimitedMultipleOptions: React.FC<Props> = (props) => {
  const [selectionOrder, setSelectionOrder] = useState(() => {
    const savedQuestion = sessionStorage.getItem("currentQuestionText");
    const currentQuestionText = props?.activeQuestion?.data?.question;

    // Only restore if it's the same question
    if (savedQuestion === currentQuestionText) {
      const saved = sessionStorage.getItem("selectionOrder");
      return saved ? JSON.parse(saved) : [];
    } else {
      // Clear old data for different question
      sessionStorage.removeItem("selectionOrder");
      sessionStorage.removeItem("checkedValues");
      return [];
    }
  });
  const [otherValue, setOtherValue] = useState<any>();

  const [checkedValues, setCheckedValues] = useState(() => {
    const savedQuestion = sessionStorage.getItem("currentQuestionText");
    const currentQuestionText = props?.activeQuestion?.data?.question;

    // Only restore if it's the same question
    if (savedQuestion === currentQuestionText) {
      const saved = sessionStorage.getItem("checkedValues");
      return saved ? JSON.parse(saved) : [];
    } else {
      return [];
    }
  });

  // Helper functions to update state and sessionStorage
  const updateSelectionOrder = (newOrder: any) => {
    setSelectionOrder(newOrder);
    sessionStorage.setItem("selectionOrder", JSON.stringify(newOrder));
    // Store current question text to track which question this data belongs to
    sessionStorage.setItem(
      "currentQuestionText",
      props?.activeQuestion?.data?.question
    );
  };

  const updateCheckedValues = (newValues: any) => {
    setCheckedValues(newValues);
    sessionStorage.setItem("checkedValues", JSON.stringify(newValues));
    // Store current question text to track which question this data belongs to
    sessionStorage.setItem(
      "currentQuestionText",
      props?.activeQuestion?.data?.question
    );
  };

  const [nextOrder, setNextOrder] = useState<number | null>(null);

  const handleCheckboxChange = (values: any) => {
    const MAX_SELECTIONS = 3;
    let updatedOrder = [...selectionOrder];

    // Handle deselection
    if (checkedValues.length > values.length) {
      // Find which item was deselected
      const deselectedValue = checkedValues.find(
        (val: any) => !values.includes(val)
      );

      // Remove the deselected item from order array (preserve other orders)
      updatedOrder = updatedOrder.filter(
        (item: any) => item.value !== deselectedValue
      );
    }
    // Handle selection
    else {
      // Find the newly selected value
      const newlySelectedValue = values.find(
        (val: any) => !checkedValues.includes(val)
      );

      if (newlySelectedValue !== undefined) {
        // If we're at max capacity, remove the item with the highest order number
        if (updatedOrder.length >= MAX_SELECTIONS) {
          const maxOrder = Math.max(...updatedOrder.map((item) => item.order));
          updatedOrder = updatedOrder.filter(
            (item: any) => item.order !== maxOrder
          );
        }

        // Find the next available order position (1, 2, or 3)
        const existingOrders = updatedOrder.map((item) => item.order);
        let nextAvailableOrder = 1;

        for (let i = 1; i <= MAX_SELECTIONS; i++) {
          if (!existingOrders.includes(i)) {
            nextAvailableOrder = i;
            break;
          }
        }

        // Add the new selection with the next available order
        updatedOrder.push({
          value: newlySelectedValue,
          order: nextAvailableOrder,
        });
      }
    }

    // setCheckedValues(values);
    // setSelectionOrder(updatedOrder);
    updateCheckedValues(values);
    updateSelectionOrder(updatedOrder);
  };

  useEffect(() => {
    let newAnswerArr = [...checkedValues, otherValue];
    if (!_.includes(checkedValues, "Other")) {
      setOtherValue(undefined);
    }
    props.form.setFieldsValue({
      [props?.activeQuestion?.data?.question]: newAnswerArr,
    });
  }, [checkedValues, otherValue]);

  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-checkbox questionlist-checkbox--input"
        name={props?.activeQuestion?.data?.question}
        rules={[
          { required: true, message: "You have to select at least one option" },
        ]}
      >
        <Checkbox.Group
          disabled={false}
          onChange={handleCheckboxChange}
          className={`${
            checkedValues?.length === 3 ? "all-checked" : ""
          } limited-multiple`}
        >
          <Row>
            {props?.activeQuestion?.options?.map((option: any, index: any) => (
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                xl={{ span: 8 }}
                key={index}
              >
                <Checkbox value={option} key={index}>
                  <span className="check-brand">
                    <span>{option}</span>
                    {checkedValues.includes(option) && (
                      <sup className="checked-number">
                        {
                          selectionOrder.find(
                            (item: any) => item.value === option
                          )?.order
                        }
                      </sup>
                    )}
                  </span>
                </Checkbox>
              </Col>
            ))}
            <Col span={24}>
              <Input
                className={`${
                  _.includes(checkedValues, "Other")
                    ? "input--option-active"
                    : ""
                }`}
                placeholder="Please Specify"
                onChange={(e) => {
                  setOtherValue(e.target.value);
                }}
                value={otherValue}
              />
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </div>
  );
};

export default LimitedMultipleOptions;
